import { useEffect } from 'react'
import { MissionTriggerModel } from '../../../../domain/model/mission-trigger.model'
import { useGame, useMissionTrigger } from '../../../contexts'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { getTeam } from '../../../utils/team_helpers'
import ImageEllipse from '../../ellipses/image_ellipse'
import PointsEllipse from '../../ellipses/points_ellipse'
import { Box } from '../../ui/components'
import { SimpleButton } from '../../ui/components/buttons/simple'
import {
  Overlay,
  Card,
  EllipseWrapper,
  Title,
  Description,
  ContentWrapper
} from './styles'

type Props = {
  isShowing: boolean;
  missionTrigger: MissionTriggerModel;
}

const Popup = ({ isShowing, missionTrigger }: Props) => {
  const { points, loadPoints, game } = useGame()
  const { handleToggleTriggerVisibility } = useMissionTrigger()
  const team = getTeam()

  useEffect(() => {
    (async () => {
      await loadPoints()
    })()
  }, [])

  let feedBackText = missionTrigger?.highlightedText
  if (team) {
    feedBackText = feedBackText?.replace('{{NomeDoTime}}', team.name)
  }

  return (
    <Overlay style={{ display: isShowing ? 'flex' : 'none' }}>
      <Card color={missionTrigger.color}>
        <EllipseWrapper>
          <ImageEllipse url={getAssetUrl('image', missionTrigger.image)} bg={game?.baseColor || '#fff'}/>
        </EllipseWrapper>

        <ContentWrapper>
          <Title color={missionTrigger.textColor}>{feedBackText}</Title>
          <Description color={missionTrigger.textColor}>{missionTrigger.regularText}</Description>

          <Box mt={'40px'}>
            {missionTrigger.options?.showPoints && <PointsEllipse color={missionTrigger.color} teamName={getTeam()?.name} points={points} bg={game?.baseColor || '#fff'}/>}
          </Box>
        </ContentWrapper>

        <Box w={'255px'}>
          <SimpleButton
            onAction={() => handleToggleTriggerVisibility(false)}
            bg={missionTrigger.buttonColor}
            color={missionTrigger.buttonTextColor}
          >{missionTrigger.buttonText}</SimpleButton>
        </Box>
      </Card>
    </Overlay>
  )
}

export default Popup
